import React from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import { translate } from '../../../services/translate';
import FormDropDownPicker from '../../../components/FormDropDownPicker';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';

const BLOCK_NATURES = [
    'manual',
    'inactivity',
    'exceeded_login_attempts',
    'expiration',
] as const;

type Props = {
    includeAllOption?: boolean;
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function BlockNatureDropdown({ form, fieldName, value, setValue, includeAllOption = true, zIndex, disabled, required, labelFontSize = 16, labelStyle, viewStyle, label }: Props) {
    const items = [
        ...(includeAllOption ? [{ value: '', label: translate('masculineAll') }] : []),
        ...BLOCK_NATURES.map((nature) => ({
            value: nature,
            label: translate(nature),
        })),
    ];

    if (form && fieldName) {
        return <FormDropDownPicker
            label={label ?? translate('reason')}
            items={items}
            multiple={false}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('reason')}
                items={items}
                multiple={false}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
                labelFontSize={labelFontSize}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
            />
        );
    }
}

export default BlockNatureDropdown;
